/**
 * Cookie Notification Module
 *
 * @module CookieNotification
 * @author EN GARDE
 * @version 1.1.1
 *
 * @requires lodash
 * @requires jQuery
 * @requires CookieHelper
 *
 * change log:
 * 	1.1.1	fixed missing dependency description
 * 	1.1		made options configurable
 * 	1.0		initial version
 */

var EN = EN || {};

EN.CookieNotification = (function (_, $, CookieHelper) {
	'use strict';

	var options = {
		selectors: {
			component: '.en-cookie-notification'
		},
		classNames: {
			hidden: 'en-hidden'
		},
		cookieName: 'en_cookie_notification_bugmenot'
	};

	/**
	 * @memberof module:CookieNotification
	 */
	var init = function (settings) {
		options = _.defaultsDeep(settings, options);
		
		var cookieName = options.cookieName;

		if (!CookieHelper.getCookie(cookieName)) {
			$(options.selectors.component)
				.removeClass(options.classNames.hidden)
				.on('submit', function (e) {
					CookieHelper.setCookie(cookieName, 1);

					$(this).addClass(options.classNames.hidden);
					e.preventDefault();
				});
		}
	};

	// exports
	return {
		init: init
	};
}(lodash, jQuery, EN.CookieHelper));
